<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <!-- <jm-crumbs /> -->
          <el-tabs value="jp">
            <el-tab-pane :label="isQcrb ? '前程语言学校文案流程' : '日本文案流程'" name="jp"></el-tab-pane>
          </el-tabs>
          <div class="searchList">
            <div class="box-content">
              <label class="form-tit">学校</label>
              <jm-school-search
                class="jm-input220"
                clearable
                :country-id="83"
                v-model="schoolModel" />
            </div>
            <div class="box-content">
              <label class="form-tit">户籍地</label>
              <jm-areaselect class="jm-input220" v-model="listInfoData.domicile" />
            </div>
            <div class="box-content">
              <label class="form-tit">最高学历</label>
              <jm-dict-select
                class="jm-input220"
                v-model="listInfoData.highestRecord1"
                dict-type="education"
                clearable/>
            </div>
            <div class="box-content">
              <label class="form-tit">启用流程</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.enableProcess"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">入学时间</label>
              <el-date-picker
                class="jm-input-common2"
                v-model="listInfoData.startSchoolDateYear"
                align="right"
                type="year"
                value-format="yyyy"
                placeholder="选择年"
                clearable/>
              <el-date-picker
                class="jm-input-common2"
                v-model="listInfoData.startSchoolDateMonth"
                type="month"
                placeholder="选择月"
                format="M"
                value-format="M"
                popper-class="process-list-popper"
                clearable/>
            </div>
            <div class="box-content" v-permission="[58]" v-if="!isQcrb"> <!-- 日本文案主管能看 -->
              <label class="form-tit">文案老师</label>
              <el-select
                class="jm-input220"
                v-model="listInfoData.crm_writer"
                placeholder="请选择"
                clearable>
                <el-option-group
                  v-for="(group, k) in teacheres"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.truename"
                    :value="item.userid" />
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content" v-permission="[76]" v-if="isQcrb"> <!-- 前程日本语言学校客服主管能看 -->
              <label class="form-tit">客服老师</label>
              <el-select
                class="jm-input220"
                v-model="listInfoData.crm_cse"
                placeholder="请选择"
                clearable>
                <el-option-group
                  v-for="(group, k) in teacheres"
                  :key="k"
                  :label="k">
                  <el-option
                    v-for="item in group"
                    :key="item.userid"
                    :label="item.truename"
                    :value="item.userid" />
                </el-option-group>
              </el-select>
            </div>
            <div class="box-content">
              <label class="form-tit">是否有延期史</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.is_delay"
                type="dataset"
                dict-type="langschool_process"
                name="delayState" />
            </div>
            <div class="box-content" v-if="listInfoData.is_delay === 2">
              <label class="form-tit">延期时间</label>
              <el-date-picker
                class="jm-input-common2"
                v-model="listInfoData.delayDateYear"
                align="right"
                type="year"
                placeholder="选择年"
                clearable/>
              <el-date-picker
                class="jm-input-common2"
                v-model="listInfoData.delayDateMonth"
                format="M"
                type="month"
                placeholder="选择月"
                clearable/>
            </div>
            <div class="box-content">
              <label class="form-tit">是否转校</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.whetherTransfer"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">已联系文案</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.had_write_teacher"
                type="dataset"
                dict-type="langschool_process"
                name="teacherOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">办理状态</label>
              <jm-dict-select
                clearable
                class="jm-input-common2"
                v-model="listInfoData.handleState"
                type="dataset"
                dict-type="langschool_process"
                name="handleState" />
              <jm-dict-select
                clearable
                class="jm-input-common2"
                v-if="listInfoData.handleState == 1"
                v-model="listInfoData.sub_status"
                type="dataset"
                dict-type="langschool_process"
                name="processSubState" />
              <jm-dict-select
                clearable
                class="jm-input-common2"
                v-if="[2, 3].indexOf(listInfoData.handleState) !== -1"
                v-model="listInfoData.sub_status1"
                type="jiemo"
                empty-value="0"
                empty-label="请选择"
                dict-type="jp_process_zhuanan"
              />
            </div>
            <div class="box-content">
              <label class="form-tit">材料完成度</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.process"
                type="dataset"
                dict-type="langschool_process"
                name="materialFinish" />
            </div>
            <div class="box-content">
              <label class="form-tit">内部终审</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.final_status"
                type="dataset"
                dict-type="langschool_process"
                name="insideFinal" />
            </div>
            <div class="box-content">
              <label class="form-tit">提交学校</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.send_school"
                type="dataset"
                dict-type="langschool_process"
                name="submitOrgOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">提交入管局</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.submit_org"
                type="dataset"
                dict-type="langschool_process"
                name="submitOrgOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">学生姓名</label>
              <el-input class="jm-input220" v-model="listInfoData.truename" />
            </div>
            <div class="box-content">
              <label class="form-tit">手机号</label>
              <el-input class="jm-input220" v-model="listInfoData.tel" />
            </div>
            <div class="box-content">
              <label class="form-tit">是否入学</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData['is_start_school']"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">登录App</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.logedApp"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">在留申请结果</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.zailiu"
                type="dataset"
                dict-type="langschool_process"
                name="deliverState" />
            </div>
            <div class="box-content">
              <label class="form-tit">在留下达放弃</label>
              <jm-dict-select
                clearable
                v-model="listInfoData.is_abandon"
                class="jm-input220"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content">
              <label class="form-tit">原件接收</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.recive_origin"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">随递随签</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.is_vip"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">当期生</label>
              <jm-dict-select
                clearable
                class="jm-input220"
                v-model="listInfoData.is_current"
                type="dataset"
                dict-type="langschool_process"
                name="booleanOptions" />
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">芥末日本vip</label>
              <el-select
                class="jm-input220"
                v-model="listInfoData.jiemo_vip"
                clearable
                placeholder="请选择">
                <el-option label="否" value="0" />
                <el-option label="是" value="1" />
              </el-select>
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">短期留学</label>
              <el-select
                class="jm-input220"
                v-model="listInfoData.short_study_abroad"
                clearable
                placeholder="请选择">
                <el-option label="否" value="0" />
                <el-option label="是" value="1" />
              </el-select>
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">是否赴日</label>
              <jm-dict-select
                v-model="listInfoData.is_gone_japan"
                class="jm-input220"
                type="jiemo"
                value-type="String"
                dict-type="jp_process_gone_japan" />
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">是否缴纳学费</label>
              <jm-dict-select
                v-model="listInfoData.is_pay_study"
                class="jm-input220"
                type="jiemo"
                value-type="String"
                dict-type="jp_process_pay_study" />
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">赴日意向</label>
              <jm-dict-select
                v-model="listInfoData.purpose_level"
                class="jm-input220"
                type="jiemo"
                value-type="String"
                dict-type="jp_process_purpose_level" />
            </div>
            <div class="box-content" v-if="!isQcrb">
              <label class="form-tit">签证递签状态</label>
              <jm-dict-select
                v-model="listInfoData.sign_status"
                class="jm-input220"
                type="jiemo"
                value-type="String"
                dict-type="jp_process_sign_status" />
            </div>
            <div class="box-content box-content-double" v-if="!isQcrb">
              <label class="form-tit">渠道</label>
              <jm-channel
                v-model="listInfoData.channel"
                clearable
                filterable/>
            </div>
          </div>
          <div class="searchBottom">
            <el-button class="jm-input-common3" type="primary" @click="() => { this.doRefresh = true; }">开始查询</el-button>
            <el-button class="jm-input-common3" type="default" @click="resetForm">重置</el-button>
            <el-button type="danger" v-if="!isQcrb && $hasPermission([58])">
              <router-link target="_blank" :to="{ name: 'messageRecord' }">消息推送</router-link>
            </el-button>
            <el-button type="success">
              <router-link target="_blank" :to="{ name: 'boarding' }">登机信息</router-link>
            </el-button>
            <el-button type="warning" v-if="$hasPermission([58, 76])">
              <router-link target="_blank" :to="{ name: this.isQcrb ? 'qcrb_jpprocessconfig' : 'jpprocessconfig' }">流程配置</router-link>
            </el-button>
          </div>
          <div class="list-botton">
            <span>批量操作：</span>
            <el-button
              size="mini"
              :disabled="buttonDisabled"
              type="primary"
              @click="patchSubmit({ send_school: 2 })">提交学校</el-button>
            <el-button
              size="mini"
              :disabled="buttonDisabled"
              type="primary"
              @click="patchSubmit({ status: 2 })">内部终审</el-button>
            <el-button
              size="mini"
              :disabled="buttonDisabled"
              type="primary"
              @click="patchSubmit({ submit_org: 2 })">提交入管局</el-button>
            <el-button
              size="mini"
              :disabled="buttonDisabled"
              type="primary"
              @click="patchSubmit({ is_start_school: 2 })">
              入学
            </el-button>
            <el-button
              size="mini"
              :disabled="buttonDisabled"
              type="primary"
              @click="patchSubmit({ zailiu: 2 })"
              v-permission="[58]"
            >
              在留下达
            </el-button>
          </div>
          <jm-tableList
            class="process-botton"
            :url="`/index/jp_process/pagetable`"
            :row-class-name="rowClassName"
            :search-data="listInfoData"
            :refresh.sync="doRefresh"
            @selection-change="handleSelectionChange"
            row-key="crmid"
            :post-data="{ qcrb: this.isQcrb }"
          >
            <el-table-column
              slot="firstColumn"
              type="selection"
              :selectable="checkSelectable" />
            <el-table-column
              slot="custom_name"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="custom_name">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.is_delay_status === 1">未定</el-tag>
                <span>
                  {{ scope.row.custom_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              slot="lastColumn"
              label="操作"
              width="250">
              <template slot-scope="scope">
                <router-link
                  target="_blank"
                  :to="{ name: detailRouterName, params: { crmid: scope.row.crmid} }">
                  <el-button
                    size="mini"
                    type="primary">{{ scope.row.process_id ? '查看' : '开始办理' }}
                  </el-button>
                </router-link>
                <span v-permission="[58, 76]">
                  <el-button
                    size="mini"
                    :type="scope.row.send_school === 1 ? 'primary' : 'warning'"
                    @click="singleSubmit(scope.row.process_id, {send_school: scope.row.send_school})"
                    v-if="inProcess(scope.row)">{{ scope.row.send_school === 1 ? '提交学校' : '取消学校' }}</el-button>
                  <el-button
                    size="mini"
                    :type="scope.row.status === 1 ? 'primary' : 'warning'"
                    @click="singleSubmit(scope.row.process_id, { status: scope.row.status})"
                    v-if="inProcess(scope.row)">{{ scope.row.status === 1 ? '内部终审' : '取消终审' }}</el-button>
                  <el-button
                    size="mini"
                    :type="scope.row.submit_org === 1 ? 'primary' : 'warning'"
                    @click="singleSubmit(scope.row.process_id,{ submit_org: scope.row.submit_org})"
                    v-if="inProcess(scope.row)">{{ scope.row.submit_org === 1 ? '提交入管局' : '取消入管局' }}</el-button>
                  <el-button
                    size="mini"
                    :type="scope.row.zailiu === 1 ? 'primary' : 'warning'"
                    @click="singleSubmit(scope.row.process_id, { zailiu: scope.row.zailiu})"
                    v-if="inProcess(scope.row)"
                  >
                    {{ scope.row.zailiu === 1 ? '在留已下达' : '取消在留下达' }}
                  </el-button>
                </span>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableList from '@/components/data/tableList.vue';
import { crumbs, jmAreaselect, jmSchoolSearch, jmDictSelect, jmChannel } from '@/components/tool/index.js';
import student from './student';
import writeProcess from './process.js';
import * as TeacherApi from '@/api/teacher.js';

export default {
  mixins: [writeProcess, student],
  data() {
    return {
      tableListDataVal: [],
      schoolModel: null,
      doRefresh: false,
      listInfoData: { // 初始数据
        schoolId: {},
        domicile: [],
        highestRecord1: '',
        enableProcess: '',
        startSchoolDateYear: '',
        startSchoolDateMonth: '',
        crm_writer: '',
        is_delay: '',
        delayDateYear: '',
        delayDateMonth: '',
        whetherTransfer: '',
        had_write_teacher: '',
        handleState: '',
        process: '',
        final_status: '',
        submit_org: '',
        send_school: '',
        truename: '',
        tel: '',
        logedApp: '',
        crm_cse: '',
        is_vip: null,
        is_current: null, // 当期,
        sub_status: null, // 办理状态为开始时的子状态
        jiemo_vip: '',
        short_study_abroad: '',
        is_abandon: null,
        recive_origin: null,
        channel: {},
        is_gone_japan: '',
        is_pay_study: '',
        purpose_level: '',
        sign_status: '',
      },
      teacheres: null,
      buttonDisabled: true,
      patchIds: null,
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    jmAreaselect,
    jmSchoolSearch,
    jmDictSelect,
    jmChannel
  },
  computed: {
    detailRouterName() {
      const routeNamePrefix = this.isQcrb ? 'qcrb_' : '';
      return `${routeNamePrefix}processDetails`;
    }
  },
  mounted() {
    this.getTeachersOptions();
  },
  methods: {
    /*
    * 非 process_id 用户添加灰色背景
    * */
    rowClassName({ row }) {
      if (!row.process_id) {
        return 'row-gray';
      }
      return '';
    },
    /*
    * 没有数据不可选中
    * */
    checkSelectable(row) {
      return this.inProcess(row);
    },
    /*
    * 是否启用 批量操作按钮
    * */
    handleSelectionChange(row) {
      let rowArr = [];
      row.forEach((item) => {
        rowArr.push(item.process_id);
      });
      this.patchIds = rowArr;
      rowArr.length <= 0 ? this.buttonDisabled = true : this.buttonDisabled = false;
    },
    /*
    * 单独取出文案老师，因为数据库字段为数字
    * */
    getTeachersOptions() {
      if (this.isQcrb) {
        TeacherApi.getCseTeachers().then(({ data }) => {
          this.teacheres = this.formatTeacher(data);
        });
        return true;
      }
      TeacherApi.getWriteTeachers().then(({ data }) => {
        this.teacheres = this.formatTeacher(data);
      });
    },
    /*
    * 清空查询条件
    * */
    resetForm() {
      Object.keys(this.listInfoData).forEach((key) => {
        this.listInfoData[key] = null;
      });
      this.listInfoData.channel = {};
      this.schoolModel = null;
    },
    /*
    * 提交学校 内部终审 入管局 在留下达 单个操作
    * */
    singleSubmit(id, status) {
      let keyStatus;
      let keyMsgStatus;
      let msg = this.submitFunc(status);
      Object.entries(status).forEach((item) => {
        keyStatus = item[0];
        keyMsgStatus = item[1];
      });
      this.$confirm(keyMsgStatus === 1 ? msg.msg : msg.msgStatus, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.saveProcess({
          id,
          [keyStatus]: status[keyStatus] === 1 ? 2 : 1
        }).then(() => {
          this.doRefresh = true;
        });
      }).catch(() => {
        this.$message.info(msg.errorMsg);
      });
    },
    /*
    * 批量操作 内部终审 入管局 单个操作
    * */
    patchSubmit(status) {
      let msg = this.submitFunc(status);
      this.$confirm(msg.msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (status.is_start_school === 2 && !this.checkImgInfo()) {
          this.$message.error('未上传签证页图片或汇款底单图片');
          return false;
        }
        this.savePatch(status).then(() => {
          this.doRefresh = true;
        });
      }).catch(() => {
        this.$message.info(msg.errorMsg);
      });
    },
    /*
    * 不同提示选择
    * */
    submitFunc(status) {
      let keyStatus;
      let msg;
      let errorMsg;
      let msgStatus;
      Object.keys(status).forEach((key) => {
        keyStatus = key;
      });
      if (keyStatus === 'send_school') {
        msg = '确认提交学校？';
        msgStatus = '确认取消学校?';
        errorMsg = '已取消提交学校';
      } else if (keyStatus === 'status') {
        msg = '确认内部终审？';
        msgStatus = '确认取消内部终审?';
        errorMsg = '已取消内部终审';
      } else if (keyStatus === 'submit_org') {
        msg = '确认提交入管局？';
        msgStatus = '确认取消入管局?';
        errorMsg = '已取消提交入管局';
      } else if (keyStatus === 'is_start_school') {
        msg = '确认该学生已入学？';
        msgStatus = '确认取消入学?';
        errorMsg = '已取消设置入学';
      } else if (keyStatus === 'zailiu') {
        msg = '确认在留已下达？';
        msgStatus = '确认取消在留下达?';
        errorMsg = '已取消在留已下达';
      } else {
        return false;
      }
      return { msg, errorMsg, msgStatus };
    },
    checkImgInfo() {
      this.$http._post({
        url: '/index/jp_process/checkImgInfo',
        data: {
          ids: this.patchIds
        }
      }).then((res) => {
        if (res.data === 0) {
          return true;
        }
        return false;
      });
    },
  },
  watch: {
    schoolModel(val) {
      this.listInfoData.schoolId = val ? val.sh_id : null;
    },
    'listInfoData.startSchoolDateYear' (val) {
      if (!val) {
        this.listInfoData.startSchoolDateMonth = '';
      }
    },
    'listInfoData.startSchoolDateMonth' () {
      if (!this.listInfoData.startSchoolDateYear) {
        this.listInfoData.startSchoolDateMonth = '';
      }
    },
    'listInfoData.delayDateYear' (val) {
      if (!val) {
        this.listInfoData.delayDateMonth = '';
      }
    },
    'listInfoData.delayDateMonth' () {
      if (!this.listInfoData.delayDateYear) {
        this.listInfoData.delayDateMonth = '';
      }
    },
    'listInfoData.handleState'(val) {
      if (val !== 1) {
        this.listInfoData.sub_status = null;
      }
    }
  }
};
</script>
<style>
  tr.row-gray {
    color: #D7D7D7
  }
</style>
<style scoped>
  .list-botton{
    margin-top:20px;
    margin-bottom: 10px;
  }
</style>
